/* src/app/forms/produtos/amazon/criacao-produto/criacao-produto-form/criacao-produto-form.component.css */
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
span {
  padding-right: 10px;
}
.data-find {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 10px;
  align-items: center;
  gap: 10px;
}
.mat-mdc-form-field {
  width: 100%;
}
.buttonicon {
  flex-basis: 10%;
  padding: 4px;
  width: 100%;
}
.main {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: 8px;
}
.main .field {
  padding-right: 6px;
  width: 100%;
  flex-basis: 90%;
}
form {
  height: 100%;
}
.amazoncontainer {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.amazoncontainer .left {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.card-container {
  height: 100%;
  display: flex;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 10px;
  overflow: auto;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
}
.card-item {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.amazoncontainer .right {
  overflow: auto;
  height: 100%;
  padding: 20px;
  width: 30%;
  border: 1px solid rgba(0, 0, 0, .087);
  display: flex;
  flex-direction: column;
}
.information {
  width: 100%;
  padding-left: 4px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, .087);
  display: flex;
  align-items: center;
  height: 40px;
}
.information .inf {
  flex-grow: 1;
  align-self: center;
}
.information .inf span {
  font-weight: 600;
}
.itemselected {
  color: red;
}
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}
.container-dados-edit {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.action {
  width: 100%;
  align-items: center;
  margin-bottom: 10px;
}
.link {
  text-decoration: underline;
  color: blue;
  font-size: 100%;
  cursor: pointer;
  margin-top: 20px;
}
.amazon-item {
  position: relative;
}
/*# sourceMappingURL=criacao-produto-form.component.css.map */
